import React, { FC } from "react"
import styled from "styled-components"
import Markdown from "markdown-to-jsx"

export const ContentCaptionFIGCAPTION = styled.figcaption.attrs({
  className: "type--text-XS font-family--sans",
})`
    text-align: center;
    color: var(--color--text-light);
    margin: var(--spacing--XS) 0 0;
    text-wrap: balance;
`

const ContentCaption: FC<{ children: string }> = ({ children }) => (
  <ContentCaptionFIGCAPTION className="ContentCaption">
    <Markdown>{children}</Markdown>
  </ContentCaptionFIGCAPTION>
)

export default ContentCaption
